import { useEffect, useRef } from "react";
import { XIcon } from "@/components/XIcon";
import { X_URL } from "@/lib/links";

const HANDLE = X_URL.split("/").pop();

export const XTimeline = ({ height = 620 }) => {
  const ref = useRef(null);

  useEffect(() => {
    const render = () => {
      if (window.twttr?.widgets && ref.current) window.twttr.widgets.load(ref.current);
    };
    if (!document.getElementById("twitter-wjs")) {
      const s = document.createElement("script");
      s.id = "twitter-wjs";
      s.src = "https://platform.twitter.com/widgets.js";
      s.async = true;
      s.onload = render;
      document.body.appendChild(s);
    } else {
      render();
    }
  }, []);

  return (
    <div>
      <div ref={ref} data-testid="x-timeline" className="min-h-[200px]">
        <a
          className="twitter-timeline"
          data-theme="dark"
          data-height={height}
          data-chrome="noheader nofooter transparent"
          href={`https://twitter.com/${HANDLE}`}
        >
          Posts by @{HANDLE}
        </a>
      </div>
      <a
        href={X_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="x-timeline-follow"
        className="mt-6 inline-flex items-center gap-2 bg-white text-[#0A1128] px-6 py-3 uppercase tracking-[0.15em] text-sm font-bold hover:bg-[#F4A261] transition-colors duration-200"
      >
        <XIcon className="w-4 h-4" /> Follow @{HANDLE}
      </a>
    </div>
  );
};
